import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-link-image-campus',
  templateUrl: './link-image-campus.component.html',
})
export class LinkImageCampusComponent {
  @Input() identifier
  @Input() data
  @Output() page = new EventEmitter()
}
